import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { BookingsModel } from 'src/models/customer/bookingModel';
import { BookingReviewAndRatingModel } from 'src/models/customer/bookingReviewAndRatingModel';
import { API_url } from 'src/services/api.setup';

const API_Controller = '/Bookings';
const cartType = 1;

export const CustomerBookingServicess = {
  getData: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getBookingsByCustomerId?customerId=${dataId}`
      );
      return response.data as BookingsModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (data) => {
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, data);
      enqueueSnackbar(`Booking Confirmed`, {
        variant: 'success'
      });
      return response.data as BookingsModel;
    } catch (error) {
      throw error;
    }
  },
  addReviewAndRating: async (data) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/addServiceOrderReview`,
        data
      );
      enqueueSnackbar(`Rating & Review Added`, {
        variant: 'success'
      });
      return response.data as BookingReviewAndRatingModel;
    } catch (error) {
      throw error;
    }
  },

  getReviewAndRating: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getServiceOrderReview?serviceOrderid=${dataId}`,
        dataId
      );

      return response.data as BookingReviewAndRatingModel;
    } catch (error) {
      throw error;
    }
  },
  getBookingById: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/get?id=${dataId}`,
        dataId
      );

      return response.data as BookingsModel;
    } catch (error) {
      throw error;
    }
  },
};
